import JdeCustomerInfo from '@/models/distributor/jdeCustomerInfo';
import SalesAgencyAddress from '@/models/distributor/SalesAgencyAddress';
import Project from '@/models/project/project';
import User from '@/models/user/user';
import RouterPaths from '@/router/paths';
import iconContact from '@/shared/icons/contact/contact.vue';
import iconMail from '@/shared/icons/mail/mail.vue';
import userIcon from '@/shared/icons/user/user.vue';
import { vxManager } from '@/store/store';
import { defineComponent } from 'vue';
import Events from '@/events';
import EventBus from '@/eventBus';

export default defineComponent({
  name: 'helpBox',
  components: {
    iconMail,
    iconContact,
    userIcon,
  },
  computed: {
    currentUser(): User | undefined {
      return vxManager.userModule.getUserInfo as User | undefined;
    },
    isOnProjectPage(): boolean {
      return !!this.$route?.params?.projectId;
    },
    currentProject(): Project | undefined {
      return this.isOnProjectPage ? vxManager.projectsModule.getCurrentProject : undefined;
    },
    distributorFilteredProject(): Project | undefined {
      const path = this.$route?.path?.replace(/\/$/, '');
      if (path !== RouterPaths.projects) {
        return undefined;
      }
      return vxManager.projectsModule.getProjectByFilteredDistributor;
    },
    projectForContactInfo(): Project | undefined {
      return this.currentProject ?? this.distributorFilteredProject;
    },
    userHasOnlyOneOrganization(): boolean {
      return (this.currentUser?.organizations?.length ?? 0) === 1;
    },
    canShowContactInfo(): boolean {
      return this.userHasOnlyOneOrganization || !!this.projectForContactInfo;
    },
    activeJdeCustomerInfo(): JdeCustomerInfo {
      if (this.userHasOnlyOneOrganization) {
        return this.currentUser?.jdeCustomerInfo ?? new JdeCustomerInfo();
      }
      return this.projectForContactInfo?.jdeCustomerInfo ?? new JdeCustomerInfo();
    },
    activeSalesAgencyAddress(): SalesAgencyAddress {
      if (this.userHasOnlyOneOrganization) {
        return this.currentUser?.salesAgencyAddress ?? new SalesAgencyAddress();
      }
      return this.projectForContactInfo?.distributor?.salesAgencyAddress ?? new SalesAgencyAddress();
    },
  },
  methods: {
    onShowCompleteOrgContactInfo() {
      EventBus.$emit(Events.showOrgCompleteContactInfo, {
        jdeCustomerInfo: this.activeJdeCustomerInfo,
        salesAgencyAddress: this.activeSalesAgencyAddress,
      });
    },
  },
});
